import {
  Typography,
  Col,
  Row,
  Form,
  Button,
  DatePicker,
  Spin,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useEffect, useRef, useState } from "react";
import { message } from "antd";
import "./AdvertiseModal.css";
import "../../common/bill-board/AddBillBoard.css";
import FloatingSelect from "../../common/floating-select/floatingSelect";
import FloatingInput from "../../common/float-input/FloatInput";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import { ReactComponent as DragImageIcon } from "../../../assests/drag-image-icon.svg";
import dayjs from "dayjs";
import { ReactComponent as CalenderIcon } from "../../../assests/Mobile_calender_Icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assests/delete-icon.svg";

import {
  advWithAmpPost,
  getAdvertisementType,
} from "../../../store/thunks/common-thunks/commonThunk";
import { useDispatch, useSelector } from "react-redux";
const { Title, Text } = Typography;
const AdvertiseVersion = ({
  adVersionOpen,
  setAdVersionOpen,
  form,
  setSelectedImageForDesktop,
  selectedImageForDesktop,
}) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [imageError, setImageError] = useState(false);
  const [imageErrorMessage, setImageErrorMessage] = useState("");
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [binaryImages, setBinaryImages] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const { isLoading } = useSelector((state) => state.advertisement);
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };
  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };

  const handleImageUpload = (event) => {
    const placement = adv_types?.find(
      (adv) => adv.id === form.getFieldValue("prefer_placement"),
    )?.position_name;
    const match = placement?.match(/(\d+)\s*\*\s*(\d+)/);
    const width = match ? parseInt(match?.[1]) : null;
    const height = match ? parseInt(match?.[2]) : null;
    const file = event.target.files[0];
    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        message.error("File size should not exceed 5MB.");
        setImageError("File size should not exceed 5MB.");
        event.target.value = "";
        return;
      }
      const img = new window.Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = () => {
        if (img.width === width && img.height === height) {
          const reader = new FileReader();
          reader.readAsArrayBuffer(file);
          reader.onload = () => {
            const fileData = {
              name: file.name,
              binary: new Blob([reader.result], { type: file.type }),
            };
            setBinaryImages(fileData);
          };
          setSelectedImageForDesktop(file);
          setSelectedImage(file);
          setImageError(false);
        } else {
          setImageErrorMessage(
            `Uploaded image has valid Width ${width}px and Height ${height}px.`,
          );
          setImageError(true);
        }
        URL.revokeObjectURL(objectUrl);
      };
    }
  };
  const { adv_types } = useSelector((state) => state.advertisement);
  useEffect(() => {
    if (adVersionOpen) dispatch(getAdvertisementType());
  }, [adVersionOpen]);

  useEffect(() => {
    setSelectedImage(selectedImageForDesktop);
  }, [selectedImageForDesktop, adVersionOpen]);

  const handleSaveDetails = async (values) => {
    // Check if binaryImages is null or empty
    if (!binaryImages || !binaryImages.binary || !binaryImages.name) {
      return message.error("Please upload an image.");
    }
    const formData = new FormData();
    formData.append("advertiser_name", values.advertiser_name);
    formData.append("contact_name", values.contact_name);
    formData.append("contact_email", values.contact_email);
    formData.append("contact_no", values.contact_no);
    formData.append("business_address", values.business_address);
    formData.append("type_of_ad", values.type_of_ad);
    formData.append("ad_title", values.ad_title);
    formData.append("ad_desc", values.ad_desc);
    formData.append("prefer_placement", values.prefer_placement);
    formData.append("start_date", new Date().toISOString());
    formData.append("end_date", new Date().toISOString());
    formData.append("web_url", values.web_url);
    formData.append("ad_image", binaryImages.binary, binaryImages.name);
    dispatch(advWithAmpPost(formData)).then(() => {
      form.resetFields();
      setSelectedImageForDesktop(null);
      setSelectedImage(null);
      setBinaryImages(null);
      setAdVersionOpen(false);
    });
  };
  const formValues = Form.useWatch([], form);
  const isSubmitDisabled = () => {
    const hasErrors = form
      ?.getFieldsError()
      ?.some(({ errors }) => errors.length);
    const requiredFields = [
      "advertiser_name",
      "contact_name",
      "contact_email",
      "contact_no",
      "business_address",
      "type_of_ad",
      "ad_title",
      "ad_desc",
      "prefer_placement",
      "budget",
      "start_date",
      "end_date",
      "web_url",
    ];

    const hasEmptyFields = requiredFields?.some((field) => {
      const value = form.getFieldValue(field);

      return (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value?.length === 0)
      );
    });
    const hasImage = !!selectedImage && !!binaryImages;
    return hasErrors || hasEmptyFields || !hasImage;
  };
  return (
    <div>
      <div className="amp-advertise-container">
        <>
          <Row className="maximize-text-row">
            <Title className="market-place-title">
              Advertise with Advertising Marketplace
            </Title>
          </Row>
          <Row style={{ display: "flex" }}>
            <Text className="maximize-text">
              Maximize your reach and connect with the industry’s most engaged
              audience on the most visited marketplace
            </Text>
          </Row>
          <Form
            className="form-container"
            style={{
              paddingRight: "0rem",
            }}
            form={form}
            onFinish={handleSaveDetails}
          >
            <Row>
              <Text className="advertiser-information">
                Advertiser Information
              </Text>
            </Row>
            <Row>
              <Form.Item
                name="advertiser_name"
                rules={[
                  {
                    required: true,
                    message: "Please input your advertise name",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Advertiser Name `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="contact_name"
                rules={[
                  {
                    required: true,
                    message: "Please input your Contact Name",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Contact Name `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="contact_email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: "Please input your contact email",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Contact Email `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="contact_no"
                rules={[
                  {
                    required: true,
                    message: "Please input your Contact Number",
                  },
                  {
                    pattern: /^\d{10}$/,
                    message: "Phone number must be exactly 10 digits",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Contact Number`}
                      {star}
                    </>
                  }
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="business_address"
                rules={[
                  {
                    required: true,
                    message: "Please input your business address",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Business Address `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <Row className="advertiser-information">Advertisement Type</Row>
            <Row gutter={[16, 16]} className="advertise-model-sub-form-row">
              <Form.Item
                name="type_of_ad"
                rules={[
                  {
                    required: true,
                    message: " Please select a advertisement type!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Select Type `}
                      {star}
                    </>
                  }
                  options={[
                    { id: "banner-add", name: "Banner Ad" },
                    {
                      id: "sponsered-listing",
                      name: "Sponsered Listing",
                    },
                    { id: "product-promotion", name: "Product Promotion" },
                    {
                      id: "other",
                      name: "Other",
                    },
                  ]}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Row>
            <Row className="advertiser-information">AD DETAILS</Row>
            <Row>
              <Form.Item
                name="ad_title"
                rules={[
                  {
                    required: true,
                    message: "Please input your add title",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Ad Title `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="ad_desc"
                rules={[
                  {
                    required: true,
                    message: "Please write ad description!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingTextArea
                  customStyles={textAreaFloatingInputStyles}
                  label={
                    <>
                      {`Ad Description `}
                      {star}
                    </>
                  }
                  className="billboard-input-feild billboard-text-area"
                ></FloatingTextArea>
              </Form.Item>
            </Row>

            <Row className="advertiser-information">Target Audience</Row>
            <Row>
              <Form.Item
                name="prefer_placement"
                rules={[
                  {
                    required: true,
                    message: "Please select a advertisement type!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Select Type `}
                      {star}
                    </>
                  }
                  isChannels={true}
                  options={adv_types?.map((adv) => ({
                    id: adv.id,
                    name: `${adv.position_name}`,
                  }))}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="budget"
                rules={[
                  {
                    required: true,
                    message: "Please input your budget",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Enter Budget `}
                      {star}
                    </>
                  }
                  maxLength={5}
                  onKeyPress={(e) => {
                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="start_date"
                rules={[
                  {
                    required: true,
                    message: "Please select the start date",
                  },
                ]}
                className="model-version-form-item-css"
              >
                <DatePicker
                  placeholder={"Start Date"}
                  className="billboard-datepicker"
                  suffixIcon={<CalenderIcon />}
                  disabledDate={disabledDate}
                  superNextIcon={false}
                  superPrevIcon={false}
                  popupClassName="start-date-calendar"
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="end_date"
                rules={[
                  {
                    required: true,
                    message: "Please select the end date",
                  },
                ]}
                className="model-version-form-item-css"
              >
                <DatePicker
                  placeholder={"End Date"}
                  className="billboard-datepicker"
                  suffixIcon={<CalenderIcon />}
                  disabledDate={disabledDate}
                  superNextIcon={false}
                  superPrevIcon={false}
                  popupClassName="end-date-calendar"
                />
              </Form.Item>
            </Row>

            <Row gutter={[16, 16]} className="advertise-model-sub-form-row">
              <Form.Item
                name="web_url"
                rules={[
                  {
                    type: "url",
                    required: true,
                    message: "  Please provide web url",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Web URL `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Row>
            <div className="advertise-upload-image">
              <Row gutter={[16, 16]} style={{ width: "100%" }}>
                {selectedImage ? (
                  <div
                    className="add-advertise-images"
                    style={{
                      backgroundImage: `url(${URL.createObjectURL(
                        selectedImage,
                      )})`,
                      alignItems: "flex-end",
                      justifyContent: "unset",
                    }}
                  >
                    <div
                      className="billboard-delete-image"
                      onClick={(e) => {
                        setSelectedImage(null);
                        setSelectedImageForDesktop(null);
                      }}
                    >
                      <DeleteIcon />
                    </div>
                  </div>
                ) : (
                  <div className="add-advertise-images">
                    <>
                      <DragImageIcon className="drag-image-icon-version" />
                      {imageError && (
                        <p style={{ color: "#d2042d" }}>
                          {imageErrorMessage}
                          <br />
                          To resize your image please go to <br />
                          <a
                            href="https://www.resizepixel.com"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            https://www.resizepixel.com
                          </a>
                        </p>
                      )}
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => fileInputRef.current?.click()}
                      >
                        <span className="drag-test-version">
                          Drag & Drop or{" "}
                        </span>
                        <span className="add-billboard-css"> Click</span>
                        <span className="upload-your-image-version">
                          {" "}
                          to Upload Your Image
                        </span>
                      </div>
                      <input
                        type="file"
                        accept="image/jpeg, image/jpg"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleImageUpload}
                      />
                      <Row className="supported-formatted-dimensions-versions">
                        <Col>
                          <div className="advertise-support-image-row-text">
                            Supported formats: JPG, JPEG (Max size: 5MB).
                          </div>
                        </Col>
                      </Row>
                    </>
                  </div>
                )}
              </Row>
            </div>
            <Row style={{ marginTop: "1.5rem" }}>
              <Button
                type="primary"
                htmlType="submit"
                className={`advertise-form-submit-button billboard-button-2 ${
                  isSubmitDisabled() ? "disabled-opacity" : ""
                }`}
                id="advertise_with_an_amp_btn"
                disabled={isSubmitDisabled()}
              >
                Submit
              </Button>
            </Row>
          </Form>
        </>
        {isLoading && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvertiseVersion;
